import { FC } from "react";
import { useTranslation } from "react-i18next";
import InfoModal from "@/components/modal/info";
import { playSound, SoundOption } from "@/helpers/playSound";

interface ProductNotFoundModalProps {
  onClose: () => void;
  invalidEanCode: string;
}

const ProductNotFoundModal: FC<ProductNotFoundModalProps> = ({ onClose, invalidEanCode }) => {
  const { t } = useTranslation();

  const onCloseTrigger = () => {
    playSound(SoundOption.Click2Lo);
    onClose();
  };

  return (
    <InfoModal
      onClose={onCloseTrigger}
      title={t("mainPage.productNotFound")}
      description={t("mainPage.productNotFoundDescription")}
      buttonText={t("ui.closeModal")}
      testId="product-not-found"
      helperText={invalidEanCode}
    />
  );
};

export default ProductNotFoundModal;
